import { SearchModes } from '@/domainLogic/index.ts';
import { TabId } from '@lmn/common-search-widget';
import type { SupportedTabId } from '../types';

const getCSWTabId = (searchMode: SearchModes): SupportedTabId => {
  switch (searchMode) {
    case SearchModes.DP:
      return TabId.DynamicPackage;
    case SearchModes.HO:
      return TabId.Hotel;
    case SearchModes.FF:
      return TabId.Flight;
    case SearchModes.TH:
      return TabId.Train;
    default:
      return TabId.DynamicPackage;
  }
};

export default getCSWTabId;
